var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.803223 10.8573L0.449669 10.5038L0.303223 10.6502V10.8573H0.803223ZM10.327 1.3335L10.6806 0.979943C10.4853 0.784681 10.1687 0.784681 9.97348 0.979943L10.327 1.3335ZM14.1366 5.14302L14.4901 5.49657C14.6854 5.30131 14.6854 4.98473 14.4901 4.78947L14.1366 5.14302ZM4.61275 14.6668V15.1668H4.81985L4.9663 15.0204L4.61275 14.6668ZM0.803223 14.6668H0.303223C0.303223 14.943 0.52708 15.1668 0.803223 15.1668L0.803223 14.6668ZM1.15678 11.2109L10.6806 1.68705L9.97348 0.979943L0.449669 10.5038L1.15678 11.2109ZM9.97348 1.68705L13.783 5.49657L14.4901 4.78947L10.6806 0.979943L9.97348 1.68705ZM13.783 4.78947L4.25919 14.3133L4.9663 15.0204L14.4901 5.49657L13.783 4.78947ZM4.61275 14.1668H0.803223V15.1668H4.61275V14.1668ZM1.30322 14.6668V10.8573H0.303223V14.6668H1.30322Z",
    fill: "#595D62"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGroup);
export default __webpack_public_path__ + "static/media/edit-group.4f48f556ee6dc0758469b1e3cda3fc38.svg";
export { ForwardRef as ReactComponent };